namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_drafts_preview, {
		width: '42rem', flex: { basis: '42rem', grow: 0, shrink: 0 },
		Content: { minWidth: 0, maxWidth: '100%', overflowWrap: 'anywhere' },
	})
}
